import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Components
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/SupplierConstants";
import { SearchField } from "../../../Components/formElements/SearchField";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import Loader from "../../../Components/Loader";

// Redux
import {
  addSampleRequestNr,
  workflowSample,
  getSampleRequestList,
} from "../../../redux/feature/supplier_app/sampleSlice";

const SampleRequestList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  localStorage.setItem("menu", "Sampling Process");
  localStorage.setItem("submenu", "Sampling List");

  const sampleListData = useSelector(
    (state) => state?.sample?.sample_request?.data || [],
  );
  const samplePagination = useSelector(
    (state) => state?.sample?.sample_request?.pagination,
  );
  const loading = useSelector(
    (state) => state?.sample?.sample_request?.status || false,
  );

  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isCardVisible, setCardVisible] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const fetchSampleRequests = (page = 1, limit = 10, search = "") => {
    const payload = {
      page,
      per_page: limit,
      searchTerm: search,
    };
    dispatch(getSampleRequestList(payload));
  };

  useEffect(() => {
    fetchSampleRequests(1, perPage, searchTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = () => {
    fetchSampleRequests(1, perPage, searchTerm);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchSampleRequests(page, perPage, searchTerm);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchSampleRequests(page, newPerPage, searchTerm);
  };

  const detailedPage = (requestNumber) => {
    dispatch(addSampleRequestNr(requestNumber));
    navigate(Constants.SAMPLE_REQUEST_ARTWORK);
  };

  const approvalPage = (requestNumber) => {
    dispatch(addSampleRequestNr(requestNumber));
    dispatch(workflowSample({}));
    navigate(Constants.SAMPLE_REQUEST_APPROVAL);
  };

  const columns = [
    {
      name: "Request Number",
      cell: (row) => {
        const reqNum = row.sampleRequestNr || row.requestNumber;
        const currentStatus = row.status || row.sampleRequestStatus;
        const isApprovalStage =
          currentStatus === "Under Review" ||
          currentStatus === "Pending Artwork Approval" ||
          currentStatus === "Approved - Ready for QAP";

        return (
          <button
            className="btnInfo"
            onClick={() =>
              isApprovalStage ? approvalPage(reqNum) : detailedPage(reqNum)
            }
          >
            {reqNum}
          </button>
        );
      },
      sortable: true,
      width: "160px",
    },
    {
      name: "Request Type",
      selector: (row) => row.requestType,
      sortable: true,
      width: "140px",
    },
    {
      name: "Business Unit",
      selector: (row) => row.businessUnit,
      sortable: true,
      width: "140px",
    },
    {
      name: "Category",
      selector: (row) => row.itemCategory,
      sortable: true,
      width: "150px",
    },
    {
      name: "Item Description",
      selector: (row) => row.itemDescription,
      sortable: true,
      width: "220px",
    },
    {
      name: "Expected Date",
      selector: (row) => row.expectedSampleDate,
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => <TableStatusField status={row.status || row.sampleRequestStatus} />,
      center: true,
      width: "180px",
    },
    {
      name: "Action",
      cell: (row) => {
        const reqNum = row.sampleRequestNr || row.requestNumber;
        const currentStatus = row.status || row.sampleRequestStatus;

        return (
          <div className="d-flex align-items-center gap-2">
            {row.requestType === "Brand" && currentStatus === "Pending Artwork" && (
              <button
                className="btnTable btn-sm"
                onClick={() => detailedPage(reqNum)}
                title="Submit Artwork"
              >
                <i className="bi bi-upload"></i> Artwork
              </button>
            )}

            {row.requestType === "Brand" &&
              (currentStatus === "Under Review" ||
                currentStatus === "Pending Artwork Approval") && (
                <button
                  className="btnTable btn-sm"
                  onClick={() => approvalPage(reqNum)}
                  title="Artwork Approval"
                >
                  <i className="bi bi-check-circle"></i> Review
                </button>
              )}

            {currentStatus === "Approved - Ready for QAP" && (
              <span className="badge bg-success-subtle text-success border border-success-subtle">
                Ready for QAP
              </span>
            )}

            {row.requestType === "Non-Brand" && (
              <span className="badge bg-info-subtle text-info-emphasis border border-info-subtle">
                In QAP
              </span>
            )}
          </div>
        );
      },
      center: true,
      width: "180px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Sample Request</h2>
            <p className="subText">Sample Requests and Details</p>
            <hr />

            {/* Search Row matching PurchaseRequisitionList */}
            <Row className="mb-3 align-items-center">
              <Col xs={12} md={8} lg={9}></Col>
              <Col xs={10} md={3} lg={2} className="d-flex justify-content-end">
                <SearchField
                  name="searchKey"
                  value={searchTerm}
                  onChange={(event) => setSearchTerm(event.target.value)}
                  onClick={handleSearch}
                  placeholder="Search Sample Requests"
                />
              </Col>
              {/* <Col xs={2} md={1} lg={1}>
                <span
                  className="filterIcon"
                  style={{ cursor: "pointer", fontSize: "24px" }}
                  onClick={handleSearch}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col> */}
            </Row>

            {/* Accordion List Table matching PurchaseRequisitionList */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SR</span>
                    </Col>
                    <Col xs={10} md={8} lg={8}>
                      <span className="headerTitle">Sample Request List</span>
                      <span className="subHeaderTitle">
                        View of Sample Requests and Status
                      </span>
                    </Col>

                    <Col xs={10} md={2} lg={2} className="headerButtonAlign">
                      <Col xs={12} md={8} lg={8} className="">
                        <button
                          className="btnTable"
                          onClick={() => navigate(Constants.SAMPLE_REQUEST_CREATE)}
                        >
                          <i className="bi bi-plus-lg"></i> Create Sample Request
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Loader isLoading={loading} className={"text-center"} />
                    {!loading && (
                      <DataTable
                        columns={columns}
                        data={sampleListData}
                        pagination
                        paginationServer
                        paginationTotalRows={samplePagination?.total || sampleListData.length}
                        paginationPerPage={perPage}
                        paginationDefaultPage={currentPage}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        highlightOnHover
                        responsive
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default SampleRequestList;
